module.exports = __webpack_public_path__ + "img/ad-yuanggongquan.d0c7ad46.jpg";